import React from 'react';

const DefaultContext = React.createContext({})
export default DefaultContext;